import { addHours, format, isBefore, isValid } from "date-fns"
import React, { useContext, useEffect, useState } from "react"
import * as styles from "./TimePicker.module.less"
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz"
import { SpaceProfileContext } from "../SpaceProfile/context"
import getTimeSlots from "../../utils/getTimeSlots"

export default ({
  startDate = new Date(),
  startTime = new Date(),
  setStartTime = () => null,
  endTime = new Date(),
  setEndTime = () => null,
  className = "",
}) => {
  const minTime = addHours(
    utcToZonedTime(zonedTimeToUtc(new Date(), null), "America/Toronto"),
    0
  )
  return (
    <div className={className}>
      <p className={"mx-0"}>
        <strong>Start time &#10230; End time</strong>
      </p>
      <div className="row">
        <TimePicker
          date={startDate}
          startTime={startTime}
          value={startTime}
          setValue={setStartTime}
          minTime={minTime}
        />
        <TimePicker
          date={startDate}
          startTime={startTime}
          value={endTime}
          setValue={setEndTime}
          minTime={minTime}
          isEndTime
        />
      </div>
    </div>
  )
}

const TimePicker = ({
  date = new Date(),
  value = new Date(),
  setValue = () => null,
  isEndTime = false,
  startTime = new Date(),
  minTime = new Date(),
}) => {
  const {
    commonData: { openingTime, closingTime },
  } = useContext(SpaceProfileContext)

  const [timeSlots, setTimeSlots] = useState([])

  useEffect(() => {
    if (!date) return

    const ts = getTimeSlots(
      openingTime,
      closingTime,
      format(date, "yyyy-MM-dd")
    )

    if (ts.length > 0) {
      if (isEndTime) {
        ts.shift()
      } else {
        ts.pop()
      }
    }

    setTimeSlots(ts)
  }, [date, openingTime, closingTime])

  return (
    <div className="col">
      <select
        className={styles.time_picker}
        value={value}
        onChange={(e) => setValue(new Date(e.target.value))}
      >
        <option value="" disabled>
          {isEndTime ? "End time" : "Start time"}
        </option>
        {timeSlots.map((time) => {
          const invalidStartTime = !startTime || !isValid(startTime)
          // && !isBefore(startTime, time)
          const isBeforeStartTime = !isBefore(startTime, time)
          return (
            <option
              value={time}
              key={time}
              disabled={
                (isEndTime && invalidStartTime) ||
                (isEndTime && isBeforeStartTime)
              }
            >
              {format(time, "hh:mm a")}
            </option>
          )
        })}
      </select>
    </div>
  )
}
